<template>
    <div class="pt-2 px-4">

        <div class="bg-lightest radius-normal border-light d-flex my-4 px-3">
            <div class="col-sm-12 pt-3" v-if="extrasArray && extrasArray.length > 0">

                <div class="w-100 darker font-weight-600">Extras</div>

                <extra-selector :reservation="reservation"></extra-selector>

            </div>

            <div class="text-center dark fs-largest pt-5 text-center mb-4 w-100" v-else>
                This event has no extras
            </div>

        </div>


    </div>
</template>

<script>
import ExtraSelector from './AddExtra/ExtraSelector'
export default {
    data: function() {
        return {

        }
    },
    props:{
        reservation: {
            type: Object
        }
    },
    computed: {
        extrasArray: function(){
            if(this.reservation.event.eventComponents.length > 0){
                // this.extraItemLoaction = 'component'
                return this.reservation.event.eventComponents
            } else if(this.reservation.event.product.extras.length > 0){
                // this.extraItemLoaction = 'item'
                return this.reservation.event.product.extras
            } else {
                return null
            }
        },
    },
    components: {
        ExtraSelector
    }
}
</script>

<style lang="scss" scoped>
.extraNameWidth{
    width: 40%;
}

.addRemoveWidth{
    width: 10%;
}

.extraRow{
    height: 3rem;
}
</style>



// WEBPACK FOOTER //
// AddExtra.vue?3fc108b1